import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupDto } from 'src/app/interfaces/groupDto';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GroupElementService {
  private readonly http = inject(HttpClient);

  // Get the group by Id
  getGroupById(groupId: number): Observable<GroupDto> {
    return this.http.get<GroupDto>(`${URL.url}${URL.group}/${groupId}`);
  }

  // Delete the group by Id
  deleteGroupById(groupId: number): Observable<void> {
    return this.http.delete<void>(`${URL.url}${URL.group}/${groupId}`);
  }
}
